export const neuro = (() => {
    const placeHolderText = 'A+O x3 Clear, no motor deficits'

    return placeHolderText
})